// extracted by mini-css-extract-plugin
export var footer = "_rw-0";
export var inherit = "_rw-1";
export var input = "_rw-2";
export var modalContent = "_rw-3";
export var quillEditor = "_rw-4";
export var subtitle = "_rw-5";